export default "/img/MN.9cf3ecdf2b8c316ae987f18293d1777e.png";